import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const RostersIndex = lazy(() => import('../rosters/RostersIndex'));
const RostersMain = lazy(() => import('../rosters/RostersMain'));
const MJSummary = lazy(() => import('../rosters/MjSummary'));
const MNSummary = lazy(() => import('../rosters/MnSummary'));
const RosterInfoUtility = lazy(
  () => import('../rosters/RosterInfoUtility/RosterInfoUtility')
);
const MjMnRoster = lazy(() => import('../rosters/MjMnRosters/MjMnRoster'));
const TwoWayPlayers = lazy(() => import('../rosters/TwoWayPlayers'));
const EligibleForDugout = lazy(
  () => import('../rosters/EligibleForDugout/EligibleForDugout')
);
const AllStarRosters = lazy(
  () => import('../rosters/SpecialRosters/AllStarRosters')
);
const PartnerLeague = lazy(
  () => import('../rosters/PartnerLeague/PartnerLeague')
);
const RosterDetails = lazy(
  () => import('../rosters/RosterDetails/RosterDetails')
);

export default [
  {
    id: NavConfig.groupConfigs.ROSTERS.id,
    path: NavConfig.groupConfigs.ROSTERS.to,
    element: (
      <RostersMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </RostersMain>
    ),
    children: [
      {
        index: true,
        element: <RostersIndex />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_MJ_MN_ROSTERS.id,
        path: NavConfig.linkConfigs.RSTR_MJ_MN_ROSTERS.to,
        element: <MjMnRoster />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_MJ_SUMMARY.id,
        path: NavConfig.linkConfigs.RSTR_MJ_SUMMARY.to,
        element: <MJSummary />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_MN_SUMMARY.id,
        path: NavConfig.linkConfigs.RSTR_MN_SUMMARY.to,
        element: <MNSummary />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_INFO_UTILITY.id,
        path: NavConfig.linkConfigs.RSTR_INFO_UTILITY.to,
        element: <RosterInfoUtility />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_ELIGIBLE_FOR_DUGOUT.id,
        path: NavConfig.linkConfigs.RSTR_ELIGIBLE_FOR_DUGOUT.to,
        element: <EligibleForDugout />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_TWO_WAY_PLAYERS.id,
        path: NavConfig.linkConfigs.RSTR_TWO_WAY_PLAYERS.to,
        element: <TwoWayPlayers />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_ALLSTAR_ROSTERS.id,
        path: NavConfig.linkConfigs.RSTR_ALLSTAR_ROSTERS.to,
        element: <AllStarRosters />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_PARTNER_LEAGUE.id,
        path: NavConfig.linkConfigs.RSTR_PARTNER_LEAGUE.to,
        element: <PartnerLeague />,
      },
      {
        id: NavConfig.linkConfigs.RSTR_DETAILS.id,
        path: NavConfig.linkConfigs.RSTR_DETAILS.to,
        element: <RosterDetails />,
      },
    ],
  },
];
